module.exports = require("core-js/library/fn/object/set-prototype-of");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/object/set-prototype-of.js